export default __webpack_public_path__ + "static/media/DSC02138.0a90cc76.jpg";